import { render, staticRenderFns } from "./resetPasswordCard.vue?vue&type=template&id=60f4bb63&scoped=true"
import script from "./resetPasswordCard.vue?vue&type=script&lang=js"
export * from "./resetPasswordCard.vue?vue&type=script&lang=js"
import style0 from "./resetPasswordCard.vue?vue&type=style&index=0&id=60f4bb63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4bb63",
  null
  
)

export default component.exports